import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniatravellerrentinpune() {



    const cardData =
    {
        keyword: 'Urbania Traveller Rent in Pune',
        heading: 'Urbania on rent in pune: Urbania Traveller Rent in Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Urbania Traveller Rent in Pune services for corporate groups, families, tourists, and event travelers across the city. Our well-maintained Force Urbania Traveller fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for airport transfers, corporate travel, weddings, sightseeing, and outstation journeys from Pune. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania Traveller hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Urbania Traveller Rent in Pune",
      "description": "Urbania Traveller Rent in Pune offers a variety of well-maintained Urbania travellers for city commutes, corporate trips, family outings, and group travel. With professional chauffeurs, ample seating, and a focus on comfort and safety, this service ensures a smooth and reliable travel experience throughout Pune."
    },
    {
      "name": "Urbania Tempo Traveller Pune",
      "description": "Urbania Tempo Traveller Pune provides spacious and comfortable Tempo Travellers suitable for group travel, city tours, and short-distance trips. Equipped with air-conditioning or non-AC options, professional drivers, and luggage space, it ensures a convenient and hassle-free journey within Pune and nearby destinations."
    },
    {
      "name": "Urbania Bus Hire Pune",
      "description": "Urbania Bus Hire Pune offers reliable and well-equipped buses for group travel, corporate tours, school trips, and family outings. With experienced chauffeurs, comfortable seating, and sufficient luggage capacity, it ensures a safe, organized, and enjoyable travel experience for large groups in and around Pune."
    },
    {
      "name": "Urbania Rental Service Pune",
      "description": "Urbania Rental Service Pune provides flexible vehicle rental solutions including travellers, buses, and AC/Non-AC options. Designed for city commutes, outstation trips, and special events, the service prioritizes timely pickups, comfortable travel, and professional chauffeur services for a seamless journey."
    },
    {
      "name": "Urbania AC Traveller Pune",
      "description": "Urbania AC Traveller Pune delivers fully air-conditioned travellers for maximum comfort during city and outstation trips. Ideal for corporate teams, family outings, and long-distance travel, the vehicles come with professional chauffeurs, spacious seating, and climate control for a relaxed and enjoyable journey."
    },
    {
      "name": "Urbania Non AC Traveller Pune",
      "description": "Urbania Non AC Traveller Pune offers budget-friendly non-air-conditioned travellers for city travel, group outings, and short-distance trips. Well-maintained vehicles, experienced drivers, and ample seating provide a safe, convenient, and reliable travel experience without compromising comfort."
    },
    {
      "name": "Corporate Urbania Traveller Pune",
      "description": "Corporate Urbania Traveller Pune provides professional transportation solutions for office trips, corporate meetings, conferences, and team outings. With executive seating, trained chauffeurs, and punctual service, it ensures reliable, comfortable, and efficient travel for corporate clients within Pune and nearby areas."
    },
    {
      "name": "Urbania for Outstation Pune",
      "description": "Urbania for Outstation Pune offers reliable vehicles for long-distance travel from Pune to nearby cities and tourist destinations. Equipped with air-conditioning, spacious seating, luggage storage, and experienced drivers, it guarantees a safe, comfortable, and stress-free journey for families, groups, and corporate travelers."
    },
    {
      "name": "Urbania Airport Transfer Pune",
      "description": "Urbania Airport Transfer Pune provides timely and hassle-free airport pick-up and drop services with ample luggage space, professional chauffeurs, and well-maintained vehicles. Ideal for business travelers and tourists, it ensures a smooth, safe, and comfortable transfer to and from Pune airport."
    },
    {
      "name": "Urbania for Family Trips Pune",
      "description": "Urbania for Family Trips Pune delivers spacious and comfortable travellers and buses for family vacations, outings, and group trips. With courteous chauffeurs, safety-focused service, and ample luggage space, families can enjoy a stress-free and pleasant travel experience within Pune and for outstation destinations."
    },
    {
      "name": "Urbania for Marriage Events Pune",
      "description": "Urbania for Marriage Events Pune provides elegant and comfortable vehicles for weddings, guests, and family members. With air-conditioned and non-AC options, well-maintained interiors, and professional chauffeurs, the service ensures a smooth, stylish, and timely travel experience during special occasions."
    },
    {
      "name": "Affordable Urbania Traveller Pune",
      "description": "Affordable Urbania Traveller Pune offers budget-friendly rental options without compromising on comfort or service quality. Ideal for families, groups, and corporate travelers, the vehicles are spacious, safe, and driven by experienced chauffeurs for a reliable and cost-effective travel experience."
    },
    {
      "name": "Chauffeur Driven Urbania Traveller Pune",
      "description": "Chauffeur Driven Urbania Traveller Pune provides stress-free travel with trained, background-verified drivers. Vehicles are well-maintained, spacious, and equipped for city and outstation travel, allowing passengers to relax and enjoy a safe, smooth, and comfortable journey."
    },
    {
      "name": "Urbania Group Travel Pune",
      "description": "Urbania Group Travel Pune specializes in organizing comfortable and safe travel for large groups, tours, corporate outings, and social events. With spacious vehicles, professional chauffeurs, and reliable service, group travel becomes seamless, efficient, and enjoyable in Pune and nearby destinations."
    },
    {
      "name": "Best Urbania Traveller Rental Pune",
      "description": "Best Urbania Traveller Rental Pune delivers top-rated Urbania rental services for travellers, buses, and group transport. Known for reliability, vehicle quality, and excellent customer service, it ensures a smooth, safe, and comfortable travel experience for individuals, families, and corporate clients in Pune."
    }
  ],
  "tableData": [
    ["Urbania Traveller Rent in Pune", "Urbania Tempo Traveller Pune"],
    ["Urbania Bus Hire Pune", "Urbania Rental Service Pune"],
    ["Urbania AC Traveller Pune", "Urbania Non AC Traveller Pune"],
    ["Corporate Urbania Traveller Pune", "Urbania for Outstation Pune"],
    ["Urbania Airport Transfer Pune", "Urbania for Family Trips Pune"],
    ["Urbania for Marriage Events Pune", "Affordable Urbania Traveller Pune"],
    ["Chauffeur Driven Urbania Traveller Pune", "Urbania Group Travel Pune"],
    ["Best Urbania Traveller Rental Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Traveller Rent in Pune",
        "WhyChoosedescription": "Urbania Traveller Rent in Pune is perfect for comfortable and spacious group travel, ideal for family trips, corporate travel, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania Traveller Rent in Pune provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania Traveller Rent in Pune comes with skilled drivers familiar with Pune city and nearby highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania Traveller Rent in Pune for competitive rates with no hidden charges, making group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Traveller Rent in Pune provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania Traveller Rent in Pune is available for hourly rentals, full-day bookings, corporate travel, wedding transportation, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania Traveller vehicles are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Traveller Rent in Pune guarantees timely pickups and dependable service, ensuring smooth and stress-free travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Traveller Rent in Pune available for local and outstation travel?',
        answer: 'Yes, Urbania Traveller Rent in Pune is available for both local city travel and outstation trips, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania Traveller Rent in Pune?',
        answer: 'You can book Urbania Traveller Rent in Pune via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania Traveller Rent in Pune for group travel?',
        answer: 'Urbania Traveller Rent in Pune provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania Traveller Rent in Pune suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round trips.',
    },
    {
        question: 'Are drivers experienced with Urbania Traveller Rent in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania Traveller Rent in Pune?',
        answer: 'Absolutely. Urbania Traveller Rent in Pune allows flexible pickup and drop-off locations across Pune and nearby areas.',
    },
    {
        question: 'Is Urbania Traveller Rent in Pune available 24x7?',
        answer: 'Yes, Urbania Traveller Rent in Pune operates 24x7 to meet your travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania Traveller Rent in Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania Traveller Rent in Pune?',
        answer: 'Urbania Traveller Rent in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prasad Kulkarni',
        feedback: 'We booked Urbania Traveller Rent in Pune for a family trip. The vehicle was spacious, clean, and extremely comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Deshmukh',
        feedback: 'Urbania Traveller Rent in Pune provided smooth and reliable service for our corporate outing. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];

































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Traveller Rent in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-traveller-pune.jpg",
  "description": "Urbania Traveller Rent in Pune offers AC and non-AC Urbania Tempo Traveller and buses for local and outstation travel. Perfect for family trips, corporate travel, airport transfers, marriage events, and group travel. Chauffeur-driven vehicles ensure safe, comfortable, and affordable journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-traveller-rent-pune"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Traveller Rent in Pune | AC & Luxury Urbania Tempo Traveller Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania Traveller Rent in Pune for local and outstation travel. AC and non-AC Urbania Tempo Traveller and buses for family trips, corporate travel, airport transfers, marriage events, and group travel. Chauffeur-driven service ensures safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Urbania Traveller Rent in Pune, Urbania Tempo Traveller Pune, Urbania Bus Hire Pune, Urbania Rental Service Pune, Urbania AC Traveller Pune, Urbania Non AC Traveller Pune, Corporate Urbania Traveller Pune, Urbania for Outstation Pune, Urbania Airport Transfer Pune, Urbania for Family Trips Pune, Urbania for Marriage Events Pune, Affordable Urbania Traveller Pune, Chauffeur Driven Urbania Traveller Pune, Urbania Group Travel Pune, Best Urbania Traveller Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/95.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniatravellerrentinpune;